import React, { useState } from "react";
import { Container, Button, Grid, Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHandshake,
  faUsers,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import AgentSignupModal from "./Modals/AgentSignupModal";
import reacircLogo from "../assets/img/reacirc-logo.png";

const RLPVIAgents = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleGetStarted = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  
  return (
    <>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          py: 3,
          textAlign: "center",
        }}
      >
        <Container>
          {/* Display the REACirc logo */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <img
              src={reacircLogo}
              alt="REACirc Logo"
              style={{ maxWidth: "100px", height: "auto" }}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <FontAwesomeIcon icon={faHandshake} size="3x" />
          </Box>
          <Typography variant="h2" fontWeight="bold">
            Welcome to <span style={{ color: "#FFD700" }}>RLP VI Agents</span>
          </Typography>
          <Typography variant="h5" sx={{ mt: 1 }}>
            Empowering RLP Agents with Exclusive Networking & Collaboration
          </Typography>
          <Typography
            variant="h6"
            sx={{ mt: 1, maxWidth: "800px", mx: "auto" }}
          >
            Join a thriving community of real estate professionals. Enhance your
            connections, collaborate effectively, and stay ahead in the
            industry.
          </Typography>
        </Container>
      </Box>

      {/* Benefits Section */}
      <Box sx={{ py: 6, backgroundColor: "#f9f9f9" }}>
        <Container>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={4} textAlign="center">
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <FontAwesomeIcon icon={faUsers} size="3x" color="#1976d2" />
              </Box>
              <Typography variant="h5" fontWeight="bold">
                Exclusive Networking
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                Connect with top-performing RLP agents across Vancouver Island
                and beyond.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} textAlign="center">
              <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                <FontAwesomeIcon icon={faLightbulb} size="3x" color="#1976d2" />
              </Box>
              <Typography variant="h5" fontWeight="bold">
                Industry Insights
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                Stay updated with the latest market trends, training, and
                industry best practices.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} textAlign="center">
              <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                <FontAwesomeIcon icon={faHandshake} size="3x" color="#1976d2" />
              </Box>
              <Typography variant="h5" fontWeight="bold">
                Collaboration Opportunities
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                Work together on listings, referrals, and marketing strategies
                to boost success.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Call to Action */}
      <Box sx={{ py: 3, textAlign: "center", backgroundColor: "#fff" }}>
        <Container>
          <Typography variant="h4" fontWeight="bold">
            Join <span style={{ color: "#1976d2" }}>RLP VI Agents</span> Today!
          </Typography>
          <Typography
            variant="body1"
            sx={{ mt: 1, maxWidth: "600px", mx: "auto" }}
          >
            Be part of an elite group of real estate professionals. Sign up now
            and take advantage of this powerful networking platform.
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#FFD700",
              color: "#000",
              mt: 3,
              borderRadius: "8px",
              fontSize: "1.2rem",
              px: 4,
              py: 1,
            }}
            onClick={handleGetStarted}
          >
            FREE: Get Started Now
          </Button>
        </Container>
      </Box>
      {/* Render the AgentSignupModal when open */}

      {openModal && (
        <AgentSignupModal open={openModal} onClose={handleCloseModal} />
      )}
    </>
  );
};

export default RLPVIAgents;
